Object.defineProperty(exports,"__esModule",{value:true});exports.default=null;

var noop=exports.noop=function noop(){return undefined;};